"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PRETTY_TYPE_BY_TYPE = {
    read: 'Trigger',
    write: 'Action',
    search: 'Action',
    search_or_write: 'Action',
    filter: 'Filter',
};
const prettyType = (typeOf) => {
    return PRETTY_TYPE_BY_TYPE[typeOf];
};
exports.default = prettyType;
